export const emptyGuid = "00000000-0000-0000-0000-000000000000";

export const IsEmptyGuid = (guid: string): boolean => {
  return guid === emptyGuid;
};
